module.exports = __webpack_public_path__ + "media/images/banner/klook/sp/rental-o_360_360_id-4d0e629ff740db9d515c23545b0aceaf.jpg";